import styled from "@emotion/styled";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const PreorderSpan = styled.span([
  FONTS.SwarovskiFutura500,
  fontColor.white,
  fontSize.x2ss,
  css`
    background-color: ${CSS_COLORS.Green};

    padding: 3px 6px;
    display: inline-block;
    text-transform: uppercase;

    max-width: 9em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `,
]);

export const PreorderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;

  z-index: 1;

  transform: translateY(-0.5em);
`;
